import { ISearchParams, SearchService } from './SearchService';

export class FacetApplied<TFacets extends string, ISearchResult> {
	protected _element: JQuery<HTMLElement>;
	protected _searchService: SearchService<TFacets, ISearchResult>;
	protected _defaultSearch: ISearchParams<TFacets>;

	constructor(
		element: JQuery<HTMLElement>,
		searchService: SearchService<TFacets, ISearchResult>,
	) {
		this._element = element;
		this._searchService = searchService;
		this._defaultSearch = searchService.config.defaultSearchParams;

		searchService.addResultsListener(() => this.render());
	}

	protected render() {
		const userFacets = this._searchService.getUserFacets();
		const clearLabel = 'Clear all filters';
		const pills: JQuery<HTMLElement>[] = [];

		const pillContainer = $(
			`<div class="facets-container">
				<div data-facets-container class="facets-applied-container"></div>
			</div>`,
		);

		const clear = $(`
			<button class="facet-clear">
				<span>${clearLabel}</span>
			</button>`).on('click', () => {
			this.handleClearAll();
		});

		if (userFacets.length) {
			userFacets.forEach((facet) => {
				facet.facetValue.forEach((value) => {
					const pill = $(`
						<button class="h-chip h-chip--icon">
							<span class="">${value}</span>
							<span class="h-chip-close">
								<svg
									class=""
									xmlns="http://www.w3.org/2000/svg"
									width="6px"
									height="6px" viewBox="0 0 5 5"><path d="M5 .503L4.497 0 2.5 1.996.503 0 0 .503 1.996 2.5 0 4.497.503 5 2.5 3.003 4.497 5 5 4.497 3.003 2.5z" fill="currentColor" fill-rule="nonzero"/></svg>
							</span>
						</button>
					`);

					pill.on('click', () => {
						// Remove the facet
						const updatedSearchParams = this._searchService.searchParams;

						updatedSearchParams.facetsData[facet.facetName] = (
							updatedSearchParams.facetsData[facet.facetName] as string[]
						).filter((item) => {
							return item !== value;
						});

						if (!updatedSearchParams.facetsData[facet.facetName].length) {
							updatedSearchParams.facetsData[facet.facetName] = [];
						}
						this._searchService.searchParams = updatedSearchParams;
					});

					pills.push(pill);
				});
			});
		}

		$('[data-facets-container]', pillContainer).append(...pills);

		if (pills.length) {
			$('[data-facets-container]', pillContainer).append(clear);
		}

		this._element.empty().append(pillContainer);
	}

	protected handleClearAll() {
		const updatedSearchParams = this._searchService.searchParams;
		updatedSearchParams.facetsData = this._defaultSearch.facetsData;
		this._searchService.searchParams = updatedSearchParams;
	}
}



// WEBPACK FOOTER //
// ./scripts/algolia/FacetApplied.ts